<template>
  <b-carousel :autoplay="false" :indicator-inside="false">
    <b-carousel-item v-for="(carousel, i) in images" :key="i">
      <span class="image carousel-image">
        <img :src="carousel" />
      </span>
    </b-carousel-item>
    <template slot="indicators" slot-scope="props">
      <span class="al image">
        <img :src="replaceImage(images[props.i])" :title="props.i" />
      </span>
    </template>
  </b-carousel>
</template>
<script>
export default {
  props: ['images'],
  methods: {
    replaceImage(data){
      if(data != "undefined" && data != "" && data != null){
        return data.replace(/\\/g, '');
      }
    }
  }
};
</script>
